import { ShopfloorLayoutSpecNode } from './shopfloor-layout-spec-node'

export class ShopfloorLayoutContext {
  public static readonly EMPTY = new ShopfloorLayoutContext('', [])

  constructor(
    public facility: string,
    public nodes: ShopfloorLayoutSpecNode[]
  ) {}
}
